import { EMPTY_LIST } from '../../../constants/common'
import { brToNewLine } from '../../../utils/common'
import { USER_INVITATION_FORM_FIELD_NAME_MESSAGE } from '../UserInvitationForm'

export function getUserStaffInvitationFormInitialNotifications() {
  return EMPTY_LIST
}

// `{{name}}` stays in the text: the backend replaces it when sending.
export function getUserStaffInvitationFormInitialValues({ t, ukLang, ukName }) {
  return {
    [USER_INVITATION_FORM_FIELD_NAME_MESSAGE]: brToNewLine(
      t('User.StaffInvitationTextKey', { lng: ukLang, ukName })
    ),
  }
}
